<div id="acom">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="inner-card">
                    <h4 class="card-title">Awards and scholarships</h4>
                    <div class="card-body text-justify">
                        <h4 class="card-title"> Awards</h4>
                        <p class="lead text-justify inner-lead">Students are motivated through awards and scholarship
                            for meritorious progress in studies, excellence in co-curricular and extracurricular
                            activities.</p>
                        <p class="lead text-justify inner-lead">Nine awards have been instituted in the names of very
                            respected members of the Kshatriya Sabha and local community.</p>
                        <ol>
                            <li>
                                <p class="inner-lead">Pt. Moti Ram memorial award</p>
                            </li>
                            <li>
                                <p class="inner-lead">Thakur Gaze Singh (Chanalheri) Memorial Award
                                </p>
                            </li>
                            <li>
                                <p class="inner-lead">Smt. Shanti Devi Panwar Memorial Award</p>
                            </li>
                            <li>
                                <p class="inner-lead">Sh. O.P.S. Panwar Memorial Award</p>
                            </li>
                            <li>
                                <p class="inner-lead">Smt. Angoori Devi Memorial Award</p>
                            </li>
                            <li>
                                <p class="inner-lead">The Munjal Memorial Award</p>
                            </li>
                            <li>
                                <p class="inner-lead">Smt. Sona Devi & Sh. Bharat Singh Tanwar Memorial Award</p>
                            </li>
                            <li>
                                <p class="inner-lead">Smt. Ramdevi and Sh. Sundar Singh Memorial Award</p>
                            </li>
                            <li>
                                <p class="inner-lead">Kumari Shubhra Tanwar Memorial Award</p>
                            </li>
                        </ol>

                        <h4 class="card-title"> Scholarships</h4>
                        <p class="lead text-justify inner-lead">Recognising and rewarding academic achievements act as
                            an incentive for those that follow to emulate them.</p>
                        <ul>
                            <li>
                                <p class="inner-lead">Scholarships are given in the form of fee concession for
                                    meritorious students from class V onwards. Students scoring 90% and above are
                                    granted concession in tuition fee.</p>
                            </li>
                            <li>
                                <p class="inner-lead">This year the school has introduced ‘The Pratap Scholarship’ in
                                    the form of handsome concession in tuition fee for the outstanding performance of
                                    the students in the class X Board Examination and in the class XI school
                                    examination.
                                </p>
                            </li>
                        </ul>
                        <div class="row text-center">
                            <div class="col-12">
                                <a href="/assets/img/achievement/4.jpg" data-lightbox="Awards"><img
                                        src="/assets/img/achievement/4.jpg" alt="Awards" class="img-fluid"></a>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>


    </div>
</div>